<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28.3 38.86"
  >
    <path
      class="cls-1"
      d="M24.91,0H3.39C1.52,0,0,1.52,0,3.39v34.18c0,.74.61,1.29,1.29,1.29.17,0,.35-.03.52-.11l10.28-5.52c.66-.29,1.36-.43,2.07-.43s1.41.14,2.07.43l10.28,5.52c.17.08.35.11.52.11.68,0,1.29-.55,1.29-1.29V3.39c0-1.87-1.52-3.39-3.39-3.39ZM25.1,34.37l-7.37-3.96-.11-.06-.12-.05c-1.06-.47-2.19-.7-3.35-.7s-2.29.24-3.35.7l-.12.05-.11.06-7.37,3.96V3.39c0-.1.08-.19.19-.19h21.52c.1,0,.19.08.19.19v30.99Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
